export type SchemaRecordSet = { [key: string]: string | SchemaRecordSet }

const stringShifter = (str: string, pointer = 0) => {
    const newArray = str.toString()
    return {
        shift: (length: number) => {
            if (isNaN(length)) {
                throw new Error('length is NaN')
            }
            const slice = newArray.slice(pointer, pointer + length)
            pointer += length
            return slice
        },
        getPointer: () => pointer,
    }
}

const _emvParser = (schema: SchemaRecordSet, hash: string) => {
    const records: Record<string, string> = {}
    const { shift, getPointer } = stringShifter(hash)
    const isTrue = true
    while (isTrue) {
        const tag = shift(2)
        const value = shift(Number(shift(2)))
        if (schema[tag]) {
            if (typeof schema[tag] === 'string') {
                records[schema[tag] as string] = value
            } else {
                Object.assign(
                    records,
                    _emvParser(schema[tag] as SchemaRecordSet, value)
                )
            }
        }
        if (getPointer() >= hash.length) {
            break
        }
    }
    return records
}

export const emvParser = (schema: SchemaRecordSet) => (hash: string) =>
    _emvParser(schema, hash)

const strategy = {
    // allow n1 payments through ipc
    filter: (url: URL) => url.hostname !== 'nambaone.app' || true,
    parser: (it: URL) =>
        emvParser({
            '00': 'qr_version',
            '01': 'qr_type',
            '32': {
                '00': 'qr_merchant_provider',
                '01': 'qr_service_id',
                '10': 'qr_account',
                '11': 'qr_transaction_id',
            },
            '33': {
                '00': 'qr_merchant_id',
            },
            '34': 'qr_comment',
            '52': 'qr_mcc',
            '53': 'qr_ccy',
            '54': 'amount',
            '63': 'qr_control_sum',
            '59': 'qr_merchant_name',
        })(decodeURIComponent(it.hash.slice(1))),
    mapper: (
        it: Record<string, string>
    ): Record<string, string | number | undefined> => ({
        ...it,
        qr_mcc: (it.qr_mcc && Number(it.qr_mcc)) || undefined,
        amount: (it.amount && Number(it.amount)) || undefined,
        qr_type:
            (it.qr_type && it.qr_type === '11' ? 'STATIC' : 'DYNAMIC') ||
            undefined,
        client_type: '1',
    }),
}

export function parse(token: string) {
    try {
        const url = new URL(token ?? window.location.href)
        return strategy.mapper(strategy.parser(url)) as
            | {
                  qr_merchant_name: string
              }
            | undefined
    } catch (e) {
        console.log(e)
    }
}
